import { auditReports } from '@mi-front/api-clients';
import { ViewLoader } from '@ui/utils';
import { useClient } from '../../../../../../../core/auth/profile/hooks/useClient';
import { ReportView } from '../../../../../../../core/reports/components/ReportView';
import { useStationsWithAudit } from '../../../../../hooks/useStationsWithAudit';
import { GipReportForm } from '../../gip-report/config/form/form';
import { useGipQueryParamsTransform } from '../../gip-report/config/form/hooks/useGipQueryParamsTransform';
import { useGipReportDefaultValues } from '../../gip-report/config/form/hooks/useGipReportDefaultValues';
import { mapValuesToGipReportDataDto } from '../../gip-report/config/utils/gip-report-values-to-data-dto';
import { useGipValuesFromReportId } from '../../gip-report/preview/hooks/useGipValuesFromState';
import { GipAlternativeReportFormActions } from './components/ReportActions';
import { GipAlternativeReportResultView } from './components/result/ReportResult';
import { GipAlternativeReportType } from './types';

type Props = Record<string, never>;

export function GipAltReportPreviewView(p: Props) {
  const stations = useStationsWithAudit();
  const client = useClient();

  const defaultValues = useGipReportDefaultValues();
  const { values: passedValues, isLoading } = useGipValuesFromReportId();

  const paramsTransform = useGipQueryParamsTransform();

  if (isLoading) {
    return <ViewLoader />;
  }

  return (
    <ReportView<GipAlternativeReportType | GipAlternativeReportType>
      download={{
        local: false,
        filename: 'gip-alternative-report',
      }}
      runOnLoad={!!passedValues}
      defaultValues={passedValues ?? defaultValues}
      queryParamsTransform={paramsTransform}
      reportFn={async (values, format) => {
        const config = mapValuesToGipReportDataDto(client.id, values, stations);

        return auditReports.executeGipAltReport(
          config,
          format ? { format } : undefined,
          format ? { responseType: 'arraybuffer' as const } : undefined,
        ) as any;
      }}
      Form={GipReportForm}
      FormActions={GipAlternativeReportFormActions}
      Result={GipAlternativeReportResultView}
    />
  );
}
